export default __webpack_public_path__ + "static/media/Slide52.69f4cfb6.PNG";